import React from 'react';

const Circle = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <g id="Ellipse_21" fill={props.fill} stroke={props.active ? '#000' : ''} strokeWidth="0.5">
        <circle cx="6" cy="6" r="6" stroke="none" />
        <circle cx="6" cy="6" r="5.75" fill="none" />
      </g>
    </svg>
  );
};
export default Circle;



// WEBPACK FOOTER //
// ./src/img/ComponentAsImage/Circle.js